import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const arezzotechConfig: TSPConfig = {
  key: 'arezzotech',
  name: 'ArezzoTech',
  imageName: 'ArezzoTech',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the username, password, and Company ID from your ArezzoTech profile. The Company ID should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Enter Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default arezzotechConfig;
